export default __webpack_public_path__ + "pgnv-assets/add33ae082028ca56629c0be07716d1c.png";